import React, { useEffect, useRef } from 'react';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import './tabs.css';
import TradingEvents2 from '../tables/trading_events';
import PublicTrades2 from '../tables/public_trades';
import Instruments3 from '../tables/instruments';
import Exchanges from '../tables/exchanges';
import Markets from '../tables/markets';
import TradingRules from '../tables/trading_rules';

import { useSelector } from 'react-redux';
import { selectIsMarketController, selectRoleId } from '../../redux/globalsSlice';
import { ROLE_ID_NOT_SET } from '../../common/common'; // adjust path as needed
import Indices from '../tables/indices';
import IndexMembers from '../tables/index_members';
import Currencies from '../tables/currencies';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '../../redux/panelPositionsSlice';

export const RefDataTabs = () => {
    const dispatch = useDispatch();

    const isMarketController = useSelector(selectIsMarketController);
    const isMarketControllerRef = useRef(isMarketController);
    const roleId = useSelector(selectRoleId);
    const userId = useSelector(state => state.globals.tsUserId);

    const savedTab = useSelector(state =>
        state.panelPositions.panelLayouts?.[userId]?.['RefDataTabs']?.activeTab
    );

    const isReady = roleId !== ROLE_ID_NOT_SET;

    useEffect(() => {
        isMarketControllerRef.current = isMarketController;
    }, [isMarketController]);

    // console.log('reference tab, isReady: ', isReady, ', is mc: ', isMarketControllerRef.current, ', roleid: ', roleId);
    if (!isReady) {
        // console.log('reference tab returning null , isReady: ', isReady );
        return null;
    }

    // ✅ compute tab count (important because of conditional tabs)
    const tabCount = isMarketControllerRef.current ? 9 : 6;

    // ✅ clamp index (prevents silent failures)
    const safeIndex =
        savedTab !== undefined && savedTab < tabCount
            ? savedTab
            : 0;

    return (
        <div className="data-tabs">
            <Tabs
                key={`${userId}-${tabCount}`} // 🔥 forces remount when structure changes
                forceRenderTabPanel={true}
                className="Tabs"
                selectedIndex={safeIndex}
                onSelect={(index) => {
                    dispatch(setActiveTab({
                        userId,
                        panelId: 'RefDataTabs',
                        tabId: index
                    }));
                }}
            >
                <TabList>
                    <Tab>Instruments</Tab>
                    {isMarketControllerRef.current && <Tab>Currencies</Tab>}
                    <Tab>Indices</Tab>
                    {isMarketControllerRef.current && <Tab>Index Members</Tab>}
                    <Tab>Exchanges</Tab>
                    <Tab>Markets</Tab>
                    <Tab>Events</Tab>
                    {isMarketControllerRef.current && <Tab>Rules</Tab>}
                    <Tab>Trades</Tab>
                </TabList>

                <TabPanel>
                    <Instruments3 />
                </TabPanel>

                {isMarketControllerRef.current && (
                    <TabPanel>
                        <Currencies />
                    </TabPanel>
                )}

                <TabPanel>
                    <Indices />
                </TabPanel>

                {isMarketControllerRef.current && (
                    <TabPanel>
                        <IndexMembers />
                    </TabPanel>
                )}

                <TabPanel>
                    <Exchanges />
                </TabPanel>

                <TabPanel>
                    <Markets />
                </TabPanel>

                <TabPanel>
                    <TradingEvents2 />
                </TabPanel>

                {isMarketControllerRef.current && (
                    <TabPanel>
                        <TradingRules />
                    </TabPanel>
                )}

                <TabPanel>
                    <PublicTrades2 />
                </TabPanel>
            </Tabs>
        </div>
    );
};